import { useEffect, useState } from 'react';
import { invoiceAPI } from '../../helpers/api/invoice';

// Manually-managed VAT/tax rates (core.VatRate), not fetched from SmartBill.
export const useVatRates = () => {
  const [vatRates, setVatRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    invoiceAPI
      .getAccountVats()
      .then((res) => {
        if (cancelled) return;
        setVatRates(res?.data?.vats || []);
        setError(null);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.message || 'Failed to load VAT rates');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { vatRates, loading, error };
};
